
module.exports = {
	status: 'ready',
	title: 'Hero',
	context: {
		title: 'Mer på Aktuellt & Press',
		items: [
			{
				title:'1 Black Hawk-helikoptrar överlämnade',
				preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
				video:'https://www.youtube.com/embed/rFxkS5PuViw',
				bgImage:'',
				bgVideo: '/video/demo-video-1.mp4'
			},
			// {
			// 	title:'2 Ubåt typ A26',
			// 	preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			// 	video:'',
			// 	bgImage:'/images/demo-background-image-cinema.jpg'
			// },
			// {
			// 	title:'Granatkastarpansarbandvagn 90',
			// 	preamble: 'Helikopter 16, av tillverkaren kallad UH-60M Black Hawk, är framtagen för att möta Försvarsmaktens akuta behov av helikoptrar för att klara sjukvårds-, trupp- och materieltransporter vid nationella- och internationella insatser.',
			// 	video:'',
			// 	bgImage:'/images/demo-background-image-1.jpg'
			// }
		]
	}
};
